import React from "react";
import { Link } from "react-router-dom";
import { FaBagShopping } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { FaBorderAll } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function Myorder() {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      {" "}
      <main className="page-content">
        <div className="tm-section tm-my-account-area bg-white tm-padding-section profile-men wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <div className="tm-myaccount tm-myaccount-fives">
                  <div className="my-profile-left">
                    <img src="assets/images/user-photo.png" />
                    <h2>{t("MO8")} </h2>
                    <p>+91 9999999999</p>
                  </div>
                  <ul className="nav tm-tabgroup tabgroup-left1">
                    <li className="nav-item">
                      <Link to="/Myprofile" className="nav-link ">
                        <FaBagShopping /> {t("MO1")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myorder" className="nav-link active ">
                        <FaBorderAll /> {t("MO14")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myaddress" className="nav-link ">
                        <i className="fas fa-map-marker-alt me-2" />{t("MO2")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Mywishlist" className="nav-link ">
                        <FaHeart />{t("MO3")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Login" className="nav-link ">
                        <LuLogOut /> {t("MO4")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="my-profile-right">
                  <div className="cart-box1 cart-box1-frist box1-frist-ID">
                    <div className="men-oderID">
                      <div className="col-lg-6 col-md-5">
                        <div className="oder-id">
                          <h2>
                          {t("C20")} - <span> #1740</span>
                          </h2>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-7">
                        <div className="oder-id oder-id-two">
                          <h2>
                          {t("MO5")}{" "}
                            <span className="prepaid-text-ones">
                              {" "}
                              ● {t("MO6")}
                            </span>
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="oderID-middle">
                      {/* <h6 class="order-details-text">Order</h6> */}
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("C3")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("T5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("MO15")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("T5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("MO15")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("T5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="order-footer-btn">
                      <div className="prepaid-text11">
                        <h2 className="text-muted">
                        {t("MO7")}
                        </h2>
                      </div>
                      <div className="cart-text-delivered delivered-four">
                        <h2>₹200</h2>
                      </div>
                    </div>
                    <div className="order-footer-btn">
                      <div className="cart-text-delivered">
                        <h2>{t("MO9")}</h2>
                      </div>
                      <div className="prepaid-text11">
                        <a
                          className="view-detail-btn"
                          href="orders-detail.html"
                        >
                          {" "}
                          {t("MO10")} ⮚
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-profile-right">
                  <div className="cart-box1 cart-box1-frist box1-frist-ID">
                    <div className="men-oderID">
                      <div className="col-lg-6 col-md-5">
                        <div className="oder-id">
                          <h2>
                          {t("C20")}- <span> #1741</span>
                          </h2>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-7">
                        <div className="oder-id oder-id-two">
                          <h2>
                          {t("MO5")}{" "}
                            <span className="prepaid-text-ones prepaid-text-ones-red">
                              {" "}
                              ● {t("MO11")}
                            </span>
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="oderID-middle">
                      {/* <h6 class="order-details-text">Order</h6> */}
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("MO15")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("MO5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("MO15")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("T5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="oderID-men112">
                        <div className="oderID-productBox align-items-center">
                          <div className="col-lg-1 col-md-2 col-3 p-0">
                            <div className="cart-photo store-photo-11">
                              <img src="assets/images/brandlogo-00.png" />
                            </div>
                          </div>
                          <div className="col-lg-9 col-md-10 col-9 p-0">
                            <div className="cart-text-innerBox">
                              <h2>{t("MO15")}</h2>
                              <p>
                                <span>
                                  {" "}
                                  {t("T4")}: <span className="text-viwe">10XL</span>
                                </span>
                                <span>
                                {t("T5")}:{" "}
                                  <span className="text-viwe"> 1.3g</span>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="order-footer-btn">
                      <div className="prepaid-text11">
                        <h2 className="text-muted">
                        {t("MO12")}
                        </h2>
                      </div>
                      <div className="cart-text-delivered delivered-four">
                        <h2>₹200</h2>
                      </div>
                    </div>
                    <div className="order-footer-btn">
                      <div className="cart-text-delivered cart-text-delivered-five">
                        <h2>{t("MO13")}</h2>
                      </div>
                      <div className="prepaid-text11">
                        <a
                          className="view-detail-btn"
                          href="orders-detail.html"
                        >
                          {" "}
                          {t("MO10")} ⮚
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Myorder;
